'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissMatch = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _pathToRegexp = require('path-to-regexp');

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Alternative zu React-Router <Match> / <Miss> die aktuell nicht
// zuverlässig funktionieren..

var MissMatch = _react2['default'].createClass({

  displayName: "MissMatch",

  render: function render() {
    var _props = this.props,
        pathname = _props.pathname,
        routes = _props.routes,
        miss = _props.miss;

    var params = {};

    var res = routes.find(function (_ref) {
      var exactly = _ref.exactly,
          pattern = _ref.pattern,
          component = _ref.component;


      if (exactly) {

        if (pattern.substr(-1) !== "/") pattern += "/";

        return pattern === pathname;
      } else {

        var keys = [];
        var re = (0, _pathToRegexp2['default'])(pattern, keys);
        var result = re.exec(pathname);

        if (result) {
          keys.forEach(function (key, i) {
            params[key.name] = result[i + 1];
          });
        }

        return !!result;
      }
    });

    var Component = res ? res.component : miss.component;

    var isComponent = Component.prototype && Component.prototype.isReactComponent;

    if (typeof Component === "function" && !isComponent) Component = Component({ params: params });

    return Component.prototype ? _react2['default'].createElement(Component, { params: params }) : Component;
  }
});

function mapStateToProps(state) {
  return {
    pathname: state.router.location.pathname
  };
}

exports.MissMatch = MissMatch = (0, _reactRedux.connect)(mapStateToProps)(MissMatch);

exports.MissMatch = MissMatch;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/components/miss-match/index.jsx
// module id = 919
// module chunks = 0